import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const roles = [
  { key: 'senior', emoji: '👵', label: 'I am a Senior', desc: 'Track my wellness and stay connected with family' },
  { key: 'family', emoji: '👨‍👩‍👧', label: 'I am Family', desc: 'Stay connected with my loved one' },
  { key: 'hca_independent', emoji: '🧑‍⚕️', label: 'I am a Caregiver', desc: 'Manage care independently' },
  { key: 'facility', emoji: '🏢', label: 'I represent a Facility', desc: 'Manage staff and residents' },
];

export default function RoleSelector() {
  const navigate = useNavigate();

  async function selectRole(role: string) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('profiles').upsert({
      id: user.id,
      role,
      subscription_status: role === 'senior' ? 'free' : 'trial',
      trial_ends_at: role === 'senior' ? null : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
    });

    if (role === 'senior') navigate('/senior/dashboard');
    else if (role === 'family') navigate('/family/connect');
    else navigate('/admin');
  }

  return (
    <div style={{minHeight:'100vh',background:'#0F172A',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <h1 style={{color:'#F1F5F9',fontSize:'1.8rem',fontWeight:'800',marginBottom:'8px',textAlign:'center'}}>Welcome to DIPPS</h1>
      <p style={{color:'#94A3B8',marginBottom:'40px',textAlign:'center'}}>Tell us who you are to get started</p>
      <div style={{display:'flex',flexDirection:'column',gap:'16px',width:'100%',maxWidth:'400px'}}>
        {roles.map(r => (
          <button key={r.key} onClick={() => selectRole(r.key)} style={{
            background:'#1E293B',
            border:'2px solid #334155',
            borderRadius:'12px',
            padding:'20px 24px',
            cursor:'pointer',
            textAlign:'left',
            transition:'border-color 0.2s'
          }}
          onMouseOver={e => e.currentTarget.style.borderColor='#38BDF8'}
          onMouseOut={e => e.currentTarget.style.borderColor='#334155'}
          >
            <div style={{fontSize:'1.5rem',marginBottom:'4px'}}>{r.emoji}</div>
            <div style={{color:'#F1F5F9',fontWeight:'700',fontSize:'1rem'}}>{r.label}</div>
            <div style={{color:'#64748B',fontSize:'0.85rem',marginTop:'2px'}}>{r.desc}</div>
          </button>
        ))}
      </div>
      <p style={{color:'#475569',fontSize:'0.8rem',marginTop:'32px'}}>Seniors are always free. All others get a 14-day free trial.</p>
    </div>
  );
   }
